<template>
	<MStateBox :loading="quarterly_performance.loading" :empty="isEmpty" class="ir-module-block">
		<CFinancialCard :quarterInfo="pageData" inOverview>
			<div class="quarter-perf-title">{{ getPerfTitle }}</div>
		</CFinancialCard>
		<slot name="footer"></slot>
	</MStateBox>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { useStore } from '@/utils/vue-api';
import CFinancialCard from '@/view/enterprise_rebuild/materials/shared/quarterly_performance/c-financial-card-abyl.vue';
import MStateBox from '@/view/enterprise_rebuild/components/MStateBox.vue';
import { useModuleData } from '@/view/enterprise_rebuild/hooks/data/useModuleData';

const { quarterly_performance } = useModuleData();

// 获取store和route实例
const store = useStore();

// 响应式数据
const pageData = ref({});

// 计算属性
const getIrMarketAndCode = computed(() => store.getters.getIrMarketAndCode);
const getIrName = computed(() => store.getters.getIrName);

const getPerfTitle = computed(() => {
	const [market, code] = getIrMarketAndCode.value;
	let curTitle = `${getIrName.value}（${code}）`;
	if (pageData.value.announcementTitle) {
		curTitle += pageData.value.announcementTitle;
	}
	return curTitle;
});

// 空状态判断
const isEmpty = computed(() => {
	const { data, empty } = quarterly_performance;
	console.log('data', data, empty);
	return empty || !Object.keys(data?.data || {}).length;
});

const flattenAndSortWithSort = obj => {
	let result = [];
	for (let year in obj) {
		obj[year].forEach(item => {
			result.push({ ...item });
		});
	}
	// 定义排序函数，优先考虑isTop，其次是年份
	result.sort((a, b) => {
		if (a.isTop !== b.isTop) {
			// 置顶的在最后
			return a.isTop ? 1 : -1;
		} else if (a.performanceYear !== b.performanceYear) {
			// 剩下的按年份排
			return a.performanceYear - b.performanceYear;
		} else {
			// 年份相同，按quarter排
			return a.quarter - b.quarter;
		}
	});
	return result;
};

const refresh = async done => {
	await quarterly_performance.refresh();
	const data = flattenAndSortWithSort(quarterly_performance.data?.data);
	pageData.value = data[data.length - 1] || {};

	done && done();
};

onMounted(() => {
	refresh();
});
</script>

<style lang="less" scoped>
.ir-module-block {
	.quarter-perf-title {
		color: #333;

		/* 15/H5-medium */
		font-family: 'PingFang SC';
		font-size: 0.15rem;
		font-style: normal;
		font-weight: 500;
		line-height: 140%; /* 21px */
	}
}
</style>
